import { LinkProps } from '@app/types'
import { Typography } from 'antd'
import NextLink from 'next/link'

export const Link: React.FC<LinkProps> = (props) => {
  const { href, as, 'aria-label': ariaLabel, children, replace, shallow, scroll, prefetch } = props

  if (typeof href === 'string' && !as && (href?.includes('http') || href?.includes('mailto'))) {
    if (props.target === '_blank')
      return (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        <Typography.Link
          {...props}
          aria-label={`${ariaLabel ?? ''} (Opens in a new window)`}
          rel={'noreferrer noopener'}
        >
          {children}
        </Typography.Link>
      )
    else
      return (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        <Typography.Link aria-label={ariaLabel} href={href} {...props}>
          {children}
        </Typography.Link>
      )
  } else {
    return (
      <NextLink passHref href={href} as={as} replace={replace} shallow={shallow} scroll={scroll} prefetch={prefetch}>
        {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
        {/* @ts-ignore */}
        <Typography.Link aria-label={ariaLabel} {...props}>
          {children}
        </Typography.Link>
      </NextLink>
    )
  }
}
